// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let GeocodingQuery = require("../propertyForms/Geocoding/GeocodingQuery.bs.js");
let Utils__Promise = require("../../../utils/Utils__Promise.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let WizardGeocodingData = require("./WizardGeocodingData.bs.js");

function useWithQuery(geocodingStatus, selectedAreaId, addressToGeocode, query, requestKey, setDuplicate, setGeocodingData, setDisplayNeighborhoods, setGeocodingStatus) {
  let geocodingTriggeredAt = React.useRef(Date.now());
  let setDisplayNeighborhoods$1 = setDisplayNeighborhoods !== undefined ? setDisplayNeighborhoods : param => {};
  React.useEffect(() => {
    let run = async () => {
      if (geocodingStatus === "Called") {
        return;
      }
      if (selectedAreaId === undefined) {
        return;
      }
      if (addressToGeocode === undefined) {
        return;
      }
      if (addressToGeocode.trim() === "") {
        return;
      }
      let triggeredAt = Date.now();
      geocodingTriggeredAt.current = triggeredAt;
      setGeocodingStatus("Called");
      let res;
      let exit = 0;
      let data;
      try {
        data = await Utils__Promise.toJsPromise(query(addressToGeocode, selectedAreaId));
        exit = 1;
      } catch (exn) {
        res = undefined;
      }
      if (exit === 1) {
        res = data;
      }
      if (triggeredAt !== geocodingTriggeredAt.current) {
        return;
      }
      setDuplicate(param => {
        if (typeof res === "object" && res.NAME === "Duplicate") {
          return Primitive_option.some(res.VAL);
        }
      });
      if (res !== undefined) {
        if (typeof res !== "object") {
          if (res === "OutsideChapterBoundaries") {
            setGeocodingData(undefined);
            return setGeocodingStatus("ErrorOutsideChapterBoundaries");
          } else {
            setGeocodingData(undefined);
            return setGeocodingStatus("Error");
          }
        }
        let variant = res.NAME;
        if (variant === "Duplicate") {
          setGeocodingData(undefined);
          return setGeocodingStatus("ErrorDuplicateListing");
        }
        if (variant === "Validated") {
          let match = res.VAL;
          setGeocodingData(WizardGeocodingData.toGeocodingData(match.coordinates, match.standardizedAddress));
          setDisplayNeighborhoods$1(match.displayNeighborhoods);
          return setGeocodingStatus("Valid");
        }
        setGeocodingData(undefined);
        return setGeocodingStatus("Error");
      }
      setGeocodingData(undefined);
      return setGeocodingStatus("Error");
    };
    run();
  }, [
    addressToGeocode,
    selectedAreaId,
    requestKey
  ]);
}

function use(geocodingStatus, selectedAreaId, addressToGeocode, clientType, existingPropertyId, setDuplicatedProperty, setGeocodingData, setDisplayNeighborhoods, setGeocodingStatus) {
  useWithQuery(geocodingStatus, selectedAreaId, addressToGeocode, (address, areaId) => GeocodingQuery.wizardQueryFn(address, areaId, clientType, existingPropertyId), clientType + ":" + Stdlib_Option.getOr(existingPropertyId, ""), setDuplicatedProperty, setGeocodingData, setDisplayNeighborhoods, setGeocodingStatus);
}

exports.useWithQuery = useWithQuery;
exports.use = use;
/* react Not a pure module */
